// Homework pages (teacher list + editor, student list + take page).
const en = {
  homeworkUi: {
    title: "Homework",
    teacherSubtitle: "Create homework, assign it and correct the copies.",
    studentSubtitle: "Your homework, from the most urgent.",
    newHomework: "New homework",
    late: "Late",
    status: { draft: "Draft", published: "Published", archived: "Archived" },
    filters: { all: "All", toReview: "To correct", draft: "Drafts", published: "Published" },
    forClass: "Class: {{name}}",
    forStudent: "Student: {{name}}",
    notAssigned: "Not assigned yet",
    due: "Due {{date}}",
    noDue: "No due date",
    dueIn: { today: "Due today", tomorrow: "Due tomorrow", days: "Due in {{count}} days", past: "Due date passed" },
    handedIn: "{{done}}/{{total}} handed in",
    toReview: "{{count}} to correct",
    edit: "Edit",
    copies: "Copies",
    preview: "Preview",
    publish: "Publish",
    unpublish: "Unpublish",
    delete: "Delete",
    confirmDelete: "Delete this homework and all its copies?",
    empty: "No homework yet. Create the first one!",
    emptyFilter: "Nothing here.",
    create: {
      title: "New homework",
      name: "Title",
      namePlaceholder: "e.g. Fractions — exercises 1 to 5",
      for: "For",
      aClass: "A class",
      aStudent: "One student",
      pickClass: "Choose a class",
      pickStudent: "Choose a student",
      noClasses: "You have no classes yet.",
      noStudents: "No students found.",
      due: "Due date",
      submit: "Create and add questions",
      cancel: "Cancel",
      hint: "It stays a draft until you publish it.",
    },
    editor: {
      title: "Edit homework",
      details: "Details",
      name: "Title",
      instructions: "Instructions for the students",
      instructionsPlaceholder: "What should they do? (optional)",
      due: "Due date",
      for: "For",
      statusDraft: "Draft — students can't see it yet",
      statusPublished: "Published — students can see it",
      statusArchived: "Archived — hidden from students",
      problemsTitle: "Before publishing:",
      noTitle: "Give the homework a title.",
      noTarget: "Choose who the homework is for.",
    },
    student: {
      sections: { todo: "To do", sent: "Sent", corrected: "Corrected" },
      empty: "No homework for now. Well done!",
      start: "Start",
      continue: "Continue",
      view: "View",
      waiting: "Waiting for correction",
      corrected: "Corrected",
      score: "{{score}} / {{max}}",
      by: "by {{name}}",
    },
    take: {
      answered: "{{done}} / {{total}} answered",
      dueLine: "To hand in {{date}}",
      lateWarning: "The due date has passed — you can still send it, it will be marked late.",
      sentTitle: "Homework sent",
      sentBody: "Sent {{date}}. Your teacher will correct it soon.",
      correctedTitle: "Homework corrected",
      correctedBody: "Your teacher corrected your homework.",
      scoreLabel: "Your score",
      editAnswers: "Change my answers",
      cancelEdit: "Cancel",
      yourAnswers: "Your answers",
      send: "Send my homework",
      sendAgain: "Send again",
      sending: "Sending…",
      confirmUnanswered: "You haven't answered {{count}} question(s). Send anyway?",
      back: "My homework",
      successTitle: "Well done!",
      successBody: "Your homework was sent to your teacher.",
      previewNote: "Preview — this is what students see. You can't send it.",
    },
    submissions: { subtitle: "{{count}} copies received" },
  },
};

const fr = {
  homeworkUi: {
    title: "Devoirs",
    teacherSubtitle: "Créez des devoirs, assignez-les et corrigez les copies.",
    studentSubtitle: "Tes devoirs, du plus urgent au moins urgent.",
    newHomework: "Nouveau devoir",
    late: "En retard",
    status: { draft: "Brouillon", published: "Publié", archived: "Archivé" },
    filters: { all: "Tous", toReview: "À corriger", draft: "Brouillons", published: "Publiés" },
    forClass: "Classe : {{name}}",
    forStudent: "Élève : {{name}}",
    notAssigned: "Pas encore assigné",
    due: "À rendre {{date}}",
    noDue: "Pas de date limite",
    dueIn: { today: "À rendre aujourd'hui", tomorrow: "À rendre demain", days: "À rendre dans {{count}} jours", past: "Date limite passée" },
    handedIn: "{{done}}/{{total}} rendus",
    toReview: "{{count}} à corriger",
    edit: "Modifier",
    copies: "Copies",
    preview: "Aperçu",
    publish: "Publier",
    unpublish: "Dépublier",
    delete: "Supprimer",
    confirmDelete: "Supprimer ce devoir et toutes ses copies ?",
    empty: "Aucun devoir pour l'instant. Créez le premier !",
    emptyFilter: "Rien ici.",
    create: {
      title: "Nouveau devoir",
      name: "Titre",
      namePlaceholder: "ex. Fractions — exercices 1 à 5",
      for: "Pour",
      aClass: "Une classe",
      aStudent: "Un élève",
      pickClass: "Choisir une classe",
      pickStudent: "Choisir un élève",
      noClasses: "Vous n'avez pas encore de classe.",
      noStudents: "Aucun élève trouvé.",
      due: "Date limite",
      submit: "Créer et ajouter les questions",
      cancel: "Annuler",
      hint: "Il reste en brouillon jusqu'à ce que vous le publiiez.",
    },
    editor: {
      title: "Modifier le devoir",
      details: "Détails",
      name: "Titre",
      instructions: "Consignes pour les élèves",
      instructionsPlaceholder: "Que doivent-ils faire ? (facultatif)",
      due: "Date limite",
      for: "Pour",
      statusDraft: "Brouillon — les élèves ne le voient pas encore",
      statusPublished: "Publié — les élèves le voient",
      statusArchived: "Archivé — caché pour les élèves",
      problemsTitle: "Avant de publier :",
      noTitle: "Donnez un titre au devoir.",
      noTarget: "Choisissez à qui le devoir est destiné.",
    },
    student: {
      sections: { todo: "À faire", sent: "Envoyés", corrected: "Corrigés" },
      empty: "Aucun devoir pour le moment. Bravo !",
      start: "Commencer",
      continue: "Continuer",
      view: "Voir",
      waiting: "En attente de correction",
      corrected: "Corrigé",
      score: "{{score}} / {{max}}",
      by: "par {{name}}",
    },
    take: {
      answered: "{{done}} / {{total}} répondues",
      dueLine: "À rendre {{date}}",
      lateWarning: "La date limite est passée — tu peux encore l'envoyer, il sera marqué en retard.",
      sentTitle: "Devoir envoyé",
      sentBody: "Envoyé {{date}}. Ton enseignant va le corriger bientôt.",
      correctedTitle: "Devoir corrigé",
      correctedBody: "Ton enseignant a corrigé ton devoir.",
      scoreLabel: "Ta note",
      editAnswers: "Modifier mes réponses",
      cancelEdit: "Annuler",
      yourAnswers: "Tes réponses",
      send: "Envoyer mon devoir",
      sendAgain: "Renvoyer",
      sending: "Envoi…",
      confirmUnanswered: "Tu n'as pas répondu à {{count}} question(s). Envoyer quand même ?",
      back: "Mes devoirs",
      successTitle: "Bravo !",
      successBody: "Ton devoir a été envoyé à ton enseignant.",
      previewNote: "Aperçu — c'est ce que voient les élèves. Vous ne pouvez pas l'envoyer.",
    },
    submissions: { subtitle: "{{count}} copie(s) reçue(s)" },
  },
};

const ar = {
  homeworkUi: {
    title: "الواجبات",
    teacherSubtitle: "أنشئ الواجبات ووزّعها وصحّح الأوراق.",
    studentSubtitle: "واجباتك، من الأكثر استعجالًا.",
    newHomework: "واجب جديد",
    late: "متأخر",
    status: { draft: "مسودة", published: "منشور", archived: "مؤرشف" },
    filters: { all: "الكل", toReview: "للتصحيح", draft: "المسودات", published: "المنشورة" },
    forClass: "القسم: {{name}}",
    forStudent: "التلميذ: {{name}}",
    notAssigned: "غير مخصّص بعد",
    due: "التسليم {{date}}",
    noDue: "بدون موعد تسليم",
    dueIn: { today: "التسليم اليوم", tomorrow: "التسليم غدًا", days: "التسليم بعد {{count}} أيام", past: "انتهى موعد التسليم" },
    handedIn: "{{done}}/{{total}} سلّموا",
    toReview: "{{count}} للتصحيح",
    edit: "تعديل",
    copies: "الأوراق",
    preview: "معاينة",
    publish: "نشر",
    unpublish: "إلغاء النشر",
    delete: "حذف",
    confirmDelete: "حذف هذا الواجب وكل أوراقه؟",
    empty: "لا توجد واجبات بعد. أنشئ أول واجب!",
    emptyFilter: "لا شيء هنا.",
    create: {
      title: "واجب جديد",
      name: "العنوان",
      namePlaceholder: "مثال: الكسور — التمارين 1 إلى 5",
      for: "لِـ",
      aClass: "قسم",
      aStudent: "تلميذ",
      pickClass: "اختر قسمًا",
      pickStudent: "اختر تلميذًا",
      noClasses: "ليس لديك أقسام بعد.",
      noStudents: "لا يوجد تلاميذ.",
      due: "موعد التسليم",
      submit: "إنشاء وإضافة الأسئلة",
      cancel: "إلغاء",
      hint: "يبقى مسودة حتى تنشره.",
    },
    editor: {
      title: "تعديل الواجب",
      details: "التفاصيل",
      name: "العنوان",
      instructions: "تعليمات للتلاميذ",
      instructionsPlaceholder: "ماذا عليهم أن يفعلوا؟ (اختياري)",
      due: "موعد التسليم",
      for: "لِـ",
      statusDraft: "مسودة — لا يراها التلاميذ بعد",
      statusPublished: "منشور — يراه التلاميذ",
      statusArchived: "مؤرشف — مخفي عن التلاميذ",
      problemsTitle: "قبل النشر:",
      noTitle: "أعطِ الواجب عنوانًا.",
      noTarget: "اختر لمن هذا الواجب.",
    },
    student: {
      sections: { todo: "للإنجاز", sent: "مُرسلة", corrected: "مصحّحة" },
      empty: "لا توجد واجبات حاليًا. أحسنت!",
      start: "ابدأ",
      continue: "واصل",
      view: "عرض",
      waiting: "في انتظار التصحيح",
      corrected: "مصحّح",
      score: "{{score}} / {{max}}",
      by: "من {{name}}",
    },
    take: {
      answered: "{{done}} / {{total}} أُجيب عنها",
      dueLine: "التسليم {{date}}",
      lateWarning: "انتهى موعد التسليم — يمكنك إرساله، وسيُسجَّل كمتأخر.",
      sentTitle: "تم إرسال الواجب",
      sentBody: "أُرسل {{date}}. سيصحّحه معلّمك قريبًا.",
      correctedTitle: "تم تصحيح الواجب",
      correctedBody: "صحّح معلّمك واجبك.",
      scoreLabel: "علامتك",
      editAnswers: "تعديل إجاباتي",
      cancelEdit: "إلغاء",
      yourAnswers: "إجاباتك",
      send: "إرسال واجبي",
      sendAgain: "إعادة الإرسال",
      sending: "جارٍ الإرسال…",
      confirmUnanswered: "لم تُجب عن {{count}} سؤال. هل تريد الإرسال رغم ذلك؟",
      back: "واجباتي",
      successTitle: "أحسنت!",
      successBody: "أُرسل واجبك إلى معلّمك.",
      previewNote: "معاينة — هذا ما يراه التلاميذ. لا يمكنك إرساله.",
    },
    submissions: { subtitle: "{{count}} ورقة مستلمة" },
  },
};

const homeworkUiTranslations = { en, fr, ar };

export default homeworkUiTranslations;
